"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _VersionsTable = _interopRequireDefault(require("./VersionsTable"));
var mapStateToProps = function mapStateToProps(state, _ref) {
  var asset = _ref.asset;
  var assetVersions = _exchangeUiPortalsStore.selectors.selectAssetVersions(state, asset);
  var canAdmin = _exchangeUiPortalsStore.selectors.selectCanAdminAsset(state, asset);
  var isPortalReArchitectureEnabled = _exchangeUiPortalsStore.selectors.selectIsPIRAEnabled(state);
  var profile = _exchangeUiPortalsStore.selectors.selectProfile(state);
  return {
    assetVersions: assetVersions,
    canAdmin: canAdmin,
    isPortalReArchitectureEnabled: isPortalReArchitectureEnabled,
    profile: profile
  };
};
var ConnectedVersionsTable = (0, _redux.compose)(_exchangeReactHooks.withRouter, _exchangeReactHooks.withUserContext, _exchangeReactHooks.withAssetPortal, _exchangeReactHooks.withConfig, _exchangeReactHooks.withAssetTypesConfiguration, _exchangeReactHooks.withModal, (0, _reactRedux.connect)(mapStateToProps))(_VersionsTable.default);
var _default = exports.default = ConnectedVersionsTable;
//# sourceMappingURL=VersionsTable.container.js.map